import { ReactNode } from "react";
import { CourseNavigator } from "@/src/components/CourseNavigator";

export function CourseShell({ children }: { children: ReactNode }) {
  return (
    <div className="course-shell">
      <CourseNavigator />
      {children}
    </div>
  );
}
